import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card, CardBody } from 'reactstrap';

import { ErrorAlert } from '../../components/GeneralError';
import { BreadCrumb } from '../../components/layout/BreadCrumb';
import { Page } from '../../components/layout/Page';
import Loading from '../../components/Loading';
import { HttpHandler } from '../../utils/HttpHandler';
import { ChargeCardInfo } from './components/ChargeCardInfo';

export const ChargeCardWrapper = () => {
	const { id } = useParams();
	const navigate = useNavigate();
	const { httpGet } = HttpHandler();
	const [isBusy, setIsBusy] = useState(true);
	const [hasError, setHasError] = useState('');
	const [cardInfo, setCardInfo] = useState({});

	const { t } = useTranslation();

	const getData = async () => {
		setIsBusy(true);
		try {
			const result = await httpGet(`/chargeTag/${id}`);
			if (result === null || result.data === null) throw new Error(t('g.noDataReturned'));

			const { description, visibleNumber, status } = result.data;

			setCardInfo({ recId: id, description, visibleNumber, status });
		} catch (error) {
			console.error(error);
			setHasError(`${((error.response || {}).data || {}).message || error.message || ''}`);
		} finally {
			setIsBusy(false);
		}
	};

	const navBackward = () => {
		navigate(-1);
	};

	useEffect(() => {
		getData();
	}, [id]);

	return (
		<Page>
			<BreadCrumb title={t('g.chargeCard')} navBackward={navBackward} />
			{isBusy ? (
				<Card>
					<CardBody>
						<Loading message= {t('g.loadingChargeCards')}/>
					</CardBody>
				</Card>
			) : hasError !== '' ? (
				<ErrorAlert message={hasError} />
			) : (
				<ChargeCardInfo chargeCard={cardInfo} />
			)}
		</Page>
	);
};
